import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
//import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css"
import Button from "react-bootstrap/Button";
import TableFilterBar from "../../../GenericComponents/TableFilterBar";
import { validateToken, callApi } from "../../../../lib/utils";
import "./PatientTable.css";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory } from "react-router";
import PatientTaskModal from "./PatientEventModal/PatientTaskModal";
import TaskNotes from "../../../GenericComponents/TaskNotes";
import GenericModal from "../../../GenericComponents/GenericModal/GenericModal";
import PulseLoader from "react-spinners/PulseLoader";
import AMEventModal from "./PatientEventModal/AMEventModal";
import Badge from "react-bootstrap/Badge";

const useViewportWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

const paginationInit = {
  currentPage: 1,
  perPage: 20,
  totalRecords: 0,
  hasNext: false,
  hasPrev: false,
  pages: 0,
  previousPageNumber: null,
  nextPageNumber: null,
};
const PatientTaskList = () => {
  const [showModal, setShowModal] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [notesModalData, setNotesModalData] = useState({});
  const [tasksList, setTasksList] = useState([]);
  const [taskCounts, setTaskCounts] = useState([]);
  const [completedTasksList, setCompletedTasksList] = useState([]);
  const [todoTasksList, setTodoTasksList] = useState([]);
  const [tasksListPagination, setTasksListPagination] =
    useState(paginationInit);
  const [completedTasksListPagination, setCompletedTasksListPagination] =
    useState(paginationInit);
  const [filterStatus, setFilterStatus] = useState(2);
  const [perPage, setPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const user = useSelector((state) => state?.user);
  const isCompactView = useViewportWidth() < 992;

  const isReadOnly = user?.roleId === 10;
  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      fetchData();
    });
  }, [currentPage, perPage, filterStatus, startDate, endDate]);

  const actionFormatter = (cell, row) => {
    if (row.isActionable) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="button-tooltip-action">{`Click To ${row?.actionButtonText}`}</Tooltip>
          }
        >
          <Button style={{ background: "#357EC7" }}>
            {row?.actionButtonText}
          </Button>
        </OverlayTrigger>
      );
    } else
      return "-";

  };

  const trendFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-3">
            Click To View Care Trend Diary
          </Tooltip>
        }
      >
        {/* <a className="iconClass">
          <span>0</span> */}
        <img
          src="/images/pharmacy_workspace/care_trend_black_icn@2x.png"
          alt=""
          className="iconStyle"
          style={{ cursor: "pointer" }}
        />
        {/* </a> */}
      </OverlayTrigger>
    );
  };

  const notesFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="button-tooltip-3">Click To View Notes</Tooltip>}
      >
        {/* <a className="iconClass">
          <span>0</span> */}
        <img
          src="/images/pharmacy_workspace/notes_black_icn@2x.png"
          alt=""
          className="iconStyle"
          style={{ cursor: "pointer" }}
        />
        {/* </a> */}
      </OverlayTrigger>
    );
  };

  const iconFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="button-tooltip-2">{row?.helpText}</Tooltip>}
      >
        <img
          src={`/images/pharmacy_workspace/${row?.icon}`}
          alt=""
          className="iconStyle"
        />
      </OverlayTrigger>
    );
  };

  const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (currentPage > 1)
      return <>{perPage * (currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };
  const dateFormatter = (cell, row) => {
    const tm = row?.taskMetadata || {};

    // Recommended display logic:
    // 1) If eventTimestampIso is present and parses to a valid date → use it.
    const iso = tm.eventTimestampIso;
    const isoMoment = iso ? moment(iso, moment.ISO_8601, true) : null;
    if (isoMoment?.isValid?.()) {
      return `${isoMoment.format("MM/DD/YYYY")} | ${isoMoment.format("hh:mm A")}`;
    }

    // 2) Else if eventDateTimeEpoch is a positive number and not -1000 → use it (ms).
    const epoch = Number(tm.eventDateTimeEpoch);
    if (Number.isFinite(epoch) && epoch > 0 && epoch !== -1000) {
      const epochMoment = moment(new Date(epoch));
      return `${epochMoment.format("MM/DD/YYYY")} | ${epochMoment.format("hh:mm A")}`;
    }

    // 3) Only for copy/display when nothing else is usable (not for logic).
    const epochMoment = moment(tm.eventDateTime, "MMM DD, YYYY hh:mm A");
    return `${epochMoment.format("MM/DD/YYYY")} | ${epochMoment.format("hh:mm A")}`;
  };

  const eventFormatter = (cell, row) => {
    return filterStatus === 2 ? row.taskDetails : row.completedTaskDetails;
  };

  const columns = [
    {
      dataField: "id",
      text: "NO",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
      id: "srNumber",
    },
    {
      dataField: "createdAt",
      text: "DATE/TIME",
      sort: true,
      formatter: dateFormatter,
      id: "createdAt",
    },
    {
      dataField: "icon",
      text: "",
      formatter: iconFormatter,
      headerStyle: () => {
        return { width: "0%" };
      },
      id: "eventIcon",
    },
    {
      dataField: "taskText",
      text: "EVENT",
      style: { textAlign: "left" },
      headerStyle: () => {
        return { width: "30%" };
      },
      formatter: eventFormatter,
      id: "taskText",
    },
    // {
    //   dataField: "taskStatus",
    //   text: "STATUS",
    //   sort:true,
    //   id:"taskStatus",
    //   headerStyle: () => {
    //     return { };
    //   },
    // },
    {
      dataField: "Trend",
      text: "CARE TREND",
      formatter: trendFormatter,
      style: { textAlign: "center", verticalAlign: "middle" },
      headerStyle: () => ({ textAlign: "center" }),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          history.push("/patient/diary");
        },
      },
      id: "careTrend",
    },
    // {
    //   dataField: "Notes",
    //   text: "NOTES",
    //   formatter: notesFormatter,
    //   events: {
    //     onClick: (e, column, columnIndex, row, rowIndex) => {
    //       handleShowNotesModal(true, row);
    //     },
    //   },
    //   id: "noteIcon",
    // },
    {
      dataField: "actionButtonText",
      text: "ACTION",
      formatter: actionFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleShowModal(true, row);
        },
      },
      id: "actionButton",
    },
  ].filter(column => {
    // Only show the action column if isReadOnly is false
    if (column.dataField === "actionButtonText" && isReadOnly) {
      return false;
    }
    return true;
  });

  const fetchData = () => {
    //let startDate = moment().subtract(29, "days").startOf("day").valueOf();
    //let endDate = moment().endOf("day").valueOf();
    let params = {
      //taskType: filterStatus === 2 ? "INFO" : "TODO",
      taskType: "INFO",
      status: "NEW",
      page: currentPage,
      limit: parseInt(perPage),
      start: startDate,
      end: endDate,
    };
    setLoading(true);
    callApi(`/api/patient/tasks`, params, "POST")
      .then((response) => {
        setTasksListPagination(response?.data.data?.pagination);
        setTasksList(response?.data?.data?.tasks);
        setTaskCounts(response?.data?.data?.counts);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        // this.setState({
        //   loading: false,
        // });
        setLoading(false);
      });
  };

  const changePage = (currentPage) => {
    setCurrentPage(currentPage);
  };
  const actionPerPage = (perPageCount) => {
    setCurrentPage(1);
    setPerPage(perPageCount);
  };

  const handleShowModal = (show, data) => {
    if (show) {
      setModalData(data);
    } else {
      setModalData({});
    }
    setShowModal(show);
  };

  const handleShowNotesModal = (show, data) => {
    if (show) {
      setNotesModalData(data);
    } else {
      setNotesModalData({});
    }
    setShowNotesModal(show);
  };
  return (
    <div>
      <TableFilterBar
        title="tasks"
        taskCounts={taskCounts}
        newTask={tasksList}
        todoTask={todoTasksList}
        completetdTask={completedTasksList}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        changePage={changePage}
        actionPerPage={actionPerPage}
        perPage={perPage}
        pagination={
          filterStatus === 2
            ? tasksListPagination
            : completedTasksListPagination
        }
      />
      {loading ?
        (<div className="pulse-loader-container"><PulseLoader
          //cssOverride={override}
          //size={50}

          color={"#70757a"}
          loading={loading}
          //speedMultiplier={1.5}
          aria-label="Loading Spinner"
          data-testid="loader"
        /></div>) :
        <BootstrapTable
          keyField="id"
          data={filterStatus === 2 ? tasksList : todoTasksList}
          columns={columns}
          striped
          hover
          condensed
          bordered={false}
          wrapperClasses="table-responsive"
        />}
      <GenericModal
        className={"patientTaskModal"}
        key="PatientTaskModal"
        showModal={showModal}
        handleShowModal={handleShowModal}
        fullscreen={isCompactView ? true : false}
        ChildComponent={
          <PatientTaskModal
            modalData={modalData}
            taskType={filterStatus === 2 ? "INFO" : ""}
            isAMEvent={true}
          />
        }
      />
      <GenericModal
        key="notes"
        showModal={showNotesModal}
        handleShowModal={handleShowNotesModal}
        ChildComponent={<TaskNotes data={notesModalData} />}
        variant={"white"}
      />
    </div>
  );
};

export default PatientTaskList;
